import React, { useState } from "react";
import { PieChart } from "react-minimal-pie-chart";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { formatFileSize } from "../../utils/common";
import CustomModal from "../CustomModal";
import { Button } from "antd";

const StorageDetails = () => {
  const { t } = useTranslation();
  const { file_type, total_volume_bytes } = useSelector(
    (state) => state.fileSlice
  );
  const [appDownloadModal, setAppDownloadModal] = useState(false);

  const { storage } = useSelector((state) => state.userSlice);

  // Color map
  const colorMapping = {
    audios: "#b491f2", // Music
    contacts: "#ffa500", // Contacts
    docs: "#ff0000", // Documents
    images: "#0057ff", // Images
    videos: "#ff69b4", // Videos
  };

  // Convert file_type to PieChart data
  const chartData = file_type
    .filter((item) => item.size > 0)
    .map((item) => ({
      title: t(`label.${item.name}`),
      value: item.size,
      color: colorMapping[item.name],
    }));

  return (
    <div className="storage-card">
      <h4 style={{ textAlign: "center" }}>{t("storageDetails.title")}</h4>

      <div
        className="circle-container"
        style={{
          position: "relative",
          width: 150,
          height: 150,
          margin: "auto",
        }}
      >
        <PieChart
          data={chartData}
          lineWidth={14}
          rounded
          animate
          startAngle={-90}
          paddingAngle={6} // Add small gaps between segments
        />

        <div
          className="center-text"
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            textAlign: "center",
          }}
        >
          <strong style={{ fontSize: 18 }}>
            {formatFileSize(total_volume_bytes)}
          </strong>
          <p style={{ margin: 0, fontSize: 13 }}>
            {t("storageDetails.used")} {storage}GB
          </p>
        </div>
      </div>

      <div
        className="legend"
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: "8px 20px",
          justifyContent: "center",
          paddingTop: "16px",
        }}
      >
        {file_type.map((item, idx) => (
          <div
            key={idx}
            style={{
              display: "flex",
              alignItems: "center",
              gap: 6,
              fontSize: 14,
            }}
          >
            <span
              style={{
                backgroundColor: colorMapping[item.name],
                width: 10,
                height: 10,
                borderRadius: "50%",
              }}
            />
            <span>{t(`label.${item.name}`)}</span>
          </div>
        ))}
      </div>

      <p
        className="upgrade-title"
        style={{ textAlign: "center", marginTop: 10 }}
      >
        {t("storageDetails.upgrade")}
      </p>
      <button
        onClick={() => setAppDownloadModal(true)}
        className="premium-btn"
        style={{ display: "block", margin: "auto" }}
      >
        {t("storageDetails.premium")}
        <br />
        <small>{t("storageDetails.trial")}</small>
      </button>

      {appDownloadModal && (
        <CustomModal
          title={<span>{t("common.upgradeToPremium")}</span>}
          visible={appDownloadModal}
          className="my-custom-modal"
          handleCancel={() => setAppDownloadModal(false)}
          // handleOk={handleDeleteUser}
          width={400}
          footer={false}
        >
          <span className="font-color">{t("messages.purchaseNote")}</span>
          <div className="figma-modal-footer">
            <Button
              onClick={() => setAppDownloadModal(false)}
              className="figma-cancel-btn"
            >
              {t("common.cancel")}
            </Button>
            <a
              href="https://play.google.com/store/apps/details?id=com.cloudstorage.mycloud.storagespace.cloudapp"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Button
                type="primary"
                onClick={(e) => {}}
                className="figma-delete-btn"
              >
                {t("common.downloadApp")}
              </Button>
            </a>
          </div>
        </CustomModal>
      )}
    </div>
  );
};

export default StorageDetails;
